import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import './i18n';
import './index.css'
import { BrowserRouter } from "react-router-dom";
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <React.StrictMode>
      <App />
    </React.StrictMode>
  </BrowserRouter>
);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
// ضع هذا في App.js أو index.js
// const resizeObserverErr = /ResizeObserver loop completed with undelivered notifications/;
// const origError = console.error;

// // تغليف console.error لمراقبة المصدر
// console.error = (...args) => {
//   if (resizeObserverErr.test(args[0])) {
//     console.group("🚨 ResizeObserver Warning Detected");
//     console.trace("📍 Stack trace (مكان التحذير):");
//     console.groupEnd();
//   }
//   origError.apply(console, args);
// };
